import { render, staticRenderFns } from "./BCardActions.vue?vue&type=template&id=2def78ff&scoped=true&"
import script from "./BCardActions.vue?vue&type=script&lang=js&"
export * from "./BCardActions.vue?vue&type=script&lang=js&"
import style0 from "./BCardActions.vue?vue&type=style&index=0&id=2def78ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def78ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2def78ff')) {
      api.createRecord('2def78ff', component.options)
    } else {
      api.reload('2def78ff', component.options)
    }
    module.hot.accept("./BCardActions.vue?vue&type=template&id=2def78ff&scoped=true&", function () {
      api.rerender('2def78ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/b-card-actions/BCardActions.vue"
export default component.exports